var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconSend = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 15.2571C2 14.8 2.33946 14.4571 2.67892 14.3429L12.976 12.5143C13.4286 12.4 13.4286 11.8286 12.976 11.6L2.67892 9.88571C2.33946 9.77143 2 9.42857 2 8.97143V7.71429V2.91429C2 2.34286 2.33946 2 2.90523 2H5.50778C5.62093 2 5.84724 2 5.96039 2.11429L21.5757 11.2571C22.1414 11.6 22.1414 12.4 21.5757 12.7429L5.96039 21.8857C5.84724 22 5.73408 22 5.50778 22H2.90523C2.45261 22 2 21.6571 2 21.0857V18V15.2571Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconSend);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "media/IconSend.f839c56d93be2389a4c0cfc873d07a61.svg";